import { type FunctionComponent, type RefObject } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { UFOSuspense } from '@trello/ufo';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyPlanner: FunctionComponent<{
  screenManagerRef: RefObject<HTMLDivElement>;
}> = ({ screenManagerRef }) => {
  const PlannerWrapper = useLazyComponent(
    () => import(/* webpackChunkName: "planner-wrapper" */ './PlannerWrapper'),
    { namedImport: 'PlannerWrapper' },
  );

  return (
    <ErrorBoundary>
      <ChunkLoadErrorBoundary fallback={null}>
        <UFOSuspense name={'planner-view'} fallback={null}>
          <PlannerWrapper screenManagerRef={screenManagerRef} />
        </UFOSuspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
